import { Button, Col, Result, Row } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const AccessRestricted = () => {
  return (
    <Row justify="center" align="middle">
      <Col style={{marginTop: '5rem'}}>
        <Result
          status="403"
          title="403"
          subTitle="Sitio no disponible temporalmente"
          extra={<Link to='/signPage'><Button type="primary">Volver</Button></Link>}
        />
      </Col>
    </Row>
  );
};

export default AccessRestricted;
